var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    { attrs: { isOpen: _vm.isOpen, closeOnClickOutside: "" } },
    [
      _c("div", { staticClass: "payment-success-wrapper" }, [
        _c("img", {
          attrs: {
            src: require("@static/img/payment-success.svg"),
            width: "72",
            height: "72",
            alt: "payment-success-icon"
          }
        }),
        _c("p", { staticClass: "title" }, [
          _vm._v("Your payment is successful!")
        ]),
        _c("p", { staticClass: "payment-success-total-amount" }, [
          _vm._v(_vm._s(_vm.currency + " " + _vm.formattedTotalAmount))
        ]),
        _c("p", { staticClass: "payment-success-create-at" }, [
          _vm._v(_vm._s(_vm.getDateTimezone(_vm.payDate, _vm.countryCode)))
        ]),
        _c("p", { staticClass: "payment-success-transaction-id" }, [
          _vm._v("Transaction ID: " + _vm._s(_vm.transactionUid))
        ]),
        _c(
          "div",
          { staticClass: "btn-wrapper" },
          [
            _c(
              "EpButton",
              {
                staticClass: "btn new-payment mr-16",
                on: { click: _vm.handleNewPayment }
              },
              [_vm._v("New Payment")]
            ),
            _c(
              "EpButton",
              {
                staticClass: "btn home-page ml-16",
                on: { click: _vm.handleHomePage }
              },
              [_vm._v("Home Page")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }